import { z } from 'zod';
import { documentSchema } from './IDocument';

export const IPersonHasDocumentSchema = documentSchema.extend({
  idPerson: z.number(),
  idPersonDocumentType: z.number(),
});

export type IPersonHasDocument = z.infer<typeof IPersonHasDocumentSchema>;
